import { useRef, useEffect } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { animateWithGsap } from "../utils/animations";
import { explore1Img, explore2Img, explore3Img, explore4Img, explore5Img, 
        explore6Img, explore7Img, exploreVideo, exploreVideo1_2, highlightSecondVideo, 
        exploreVideo2, exploreVideo3, exploreVideo4, explore8Img, explore9Img, explore10Img, neuralportIntro, neuralPortPlot1img, neuralPortPlot1img2} from "../utils";


const Features = () => {
  const videoRefNeuralIntro = useRef();
  const videoRefNeuralSide = useRef();
  const videoRefBotlabMain = useRef();
  const videoRefBotlabSide = useRef();
  const videoRefResearchMain = useRef();
  const videoRefResearchSide1 = useRef();
  const videoRefResearchSide2 = useRef();


  useGSAP(() => {
    gsap.to("#neuralportIntro", {
      scrollTrigger: {
        trigger: "#neuralportIntro",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete: () => {
        if (videoRefNeuralIntro.current) videoRefNeuralIntro.current.play();
      },
    });

    gsap.to("#exploreVideoNeuralSide", {
      scrollTrigger: {
        trigger: "#exploreVideoNeuralSide",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete: () => {
        if (videoRefNeuralSide.current) videoRefNeuralSide.current.play();
      },
    });

    gsap.to("#exploreVideoBotlab", {
      scrollTrigger: {
        trigger: "#exploreVideoBotlab",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete: () => {
        if (videoRefBotlabMain.current) videoRefBotlabMain.current.play();
      },
    });

    gsap.to("#exploreVideoBotlabSide", {
      scrollTrigger: {
        trigger: "#exploreVideoBotlabSide",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete: () => {
        if (videoRefBotlabSide.current) videoRefBotlabSide.current.play();
      },
    });

    gsap.to("#exploreVideoResearchMain", {
      scrollTrigger: {
        trigger: "#exploreVideoResearchMain",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete: () => {
        if (videoRefResearchMain.current) videoRefResearchMain.current.play();
      },
    });

    gsap.to("#exploreVideoResearchSide1", {
      scrollTrigger: {
        trigger: "#exploreVideoResearchSide1",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete: () => {
        if (videoRefResearchSide1.current) videoRefResearchSide1.current.play();
      },
    });

    gsap.to("#exploreVideoResearchSide2", {
      scrollTrigger: {
        trigger: "#exploreVideoResearchSide2",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete: () => {
        if (videoRefResearchSide2.current) videoRefResearchSide2.current.play();
      },
    });

    animateWithGsap("#features_title_1", { y: 0, opacity: 1 });
    animateWithGsap("#features_title_2", { y: 0, opacity: 1 });
    animateWithGsap("#features_title_3", { y: 0, opacity: 1 });
    animateWithGsap("#features_title_4", { y: 0, opacity: 1 });
    animateWithGsap("#features_title_5", { y: 0, opacity: 1 });

    animateWithGsap(
      ".g_grow",
      {
        scale: 1,
        opacity: 1,
        ease: "power1",
      },
      {
        scrub: 5.5,
      }
    );

    animateWithGsap(".g_text_1", {
      y: [10, 0],
      opacity: 1,
      ease: "power2.inOut",
      duration: 1.2,
    });
    
    animateWithGsap(".g_text_2", {
      y: [10, 0],
      opacity: 1,
      ease: "power2.inOut",
      duration: 1.2,
    });

    animateWithGsap(".g_text_3", {
      y: [10, 0],
      opacity: 1,
      ease: "power2.inOut",
      duration: 1.2,
    });

    animateWithGsap(".g_text_4", {
      y: [10, 0],
      opacity: 1,
      ease: "power2.inOut",
      duration: 1.2,
    });

    animateWithGsap(".g_text_5", {
      y: [10, 0],
      opacity: 1,
      ease: "power2.inOut",
      duration: 1.2,
    });
  
  }, []);


  return (
    <>
    {/* First Section - NeuralPort */}
    <section id="experience-neuralport" className="h-full bg-zinc relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="w-full">
          <h1 className="text-3xl lg:text-4xl font-semibold">
            My Experience
          </h1>
        </div>

        <div className="flex flex-col justify-center items-center overflow-hidden">
          <div className="mt-10 mb-4 text-center md:ml-24 md:text-left">
            <h2 id="features_title_1" className="text-3xl md:text-4xl font-semibold mb-8 leading-tight text-center">
              <b>NeuralPort Japan 🇯🇵</b> - Sports Data Analytics<br /> Next Gen VR and <u> Sports Analytics</u> 
            </h2>
          </div>

          <div className="flex-center flex-col sm:px-10">
            <a href="#_" className="relative inline-block text-lg group">
              <span className="relative z-10 block px-5 py-3 overflow-hidden font-medium leading-tight text-gray-800 transition-colors duration-300 ease-out border-2 border-gray-900 rounded-lg group-hover:text-white">
                <span className="absolute inset-0 w-full h-full px-5 py-3 rounded-lg bg-gray-50"></span>
                <span className="absolute left-0 w-48 h-48 -ml-2 transition-all duration-300 origin-top-right -rotate-90 -translate-x-full translate-y-12 bg-gray-200 group-hover:-rotate-180 ease"></span>
                <span className="relative">NeuralPort Japan 🇯🇵</span>
              </span>
              <span className="absolute bottom-0 right-0 w-full h-12 -mb-1 -mr-1 transition-all duration-200 ease-linear bg-gray-200 rounded-lg group-hover:mb-0 group-hover:mr-0" data-rounded="rounded-lg"></span>
            </a>

            <div className="relative h-[50vh] mt-5 w-full flex items-center">
              <video
                playsInline
                id="neuralportIntro"
                className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                preload="none"
                muted
                autoPlay
                ref={videoRefNeuralIntro}
              >
                <source src={neuralportIntro} type="video/mp4" />
              </video>
            </div>

            <div className="flex flex-col mt-6 w-full relative">
              <div className="flex flex-col md:flex-row gap-6 feature-video-container">
                <div className="overflow-hidden rounded-md flex-1 h-[50vh]">
                  <img src={neuralPortPlot1img} alt="titanium" className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]" />
                </div>

                <div className="overflow-hidden rounded-md flex-1 h-[50vh]">
                  <img src={neuralPortPlot1img2} alt="titanium" className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]" />
                </div>
              </div>

              <div className="feature-text-container2 p-3 grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex-1 flex-center">
                  <p className="feature-text g_text_1">
                    Role: Sports Data Analytic{" "}
                    <span className="text-white">Worked with Kawasagi baseball team </span> 
                    <b>and MANY MORE</b>
                  </p>
                </div>

                <div className="flex-1 flex-center">
                  <p className="feature-text g_text_1">
                    Technologies Used: Python, Matlplotlib, Plotly.{" "}
                    <span className="text-white">Conducted FOUNDATIONAL analysis.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Second Section - BotLab */}
      <section id="experience-botlab" className="h-full bg-zinc relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 md:px-10">

          <div className="flex flex-col justify-center items-center overflow-hidden">
            <div className="mt-10 mb-4 text-center md:ml-24 md:text-left">
              <h2 id="features_title_2" className="text-3xl md:text-4xl font-semibold mb-8 leading-tight text-center">
                <b>Botlab Dynamics</b> - Drone Shows<br /> Landed a role in <u>IIT Startup</u> 
              </h2>
            </div>

            <div className="flex-center flex-col sm:px-10">
              <a href="#_" className="relative inline-block text-lg group">
                <span className="relative z-10 block px-5 py-3 overflow-hidden font-medium leading-tight text-gray-800 transition-colors duration-300 ease-out border-2 border-gray-900 rounded-lg group-hover:text-white">
                  <span className="absolute inset-0 w-full h-full px-5 py-3 rounded-lg bg-gray-50"></span>
                  <span className="absolute left-0 w-48 h-48 -ml-2 transition-all duration-300 origin-top-right -rotate-90 -translate-x-full translate-y-12 bg-gray-200 group-hover:-rotate-180 ease"></span>
                  <span className="relative">BotLab Dynamics</span>
                </span>
                <span className="absolute bottom-0 right-0 w-full h-12 -mb-1 -mr-1 transition-all duration-200 ease-linear bg-gray-200 rounded-lg group-hover:mb-0 group-hover:mr-0" data-rounded="rounded-lg"></span>
              </a>

              <div className="relative h-[50vh] mt-5 w-full flex items-center">
                <video
                  playsInline
                  id="exploreVideoBotlab"
                  className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                  preload="none"
                  muted
                  autoPlay
                  ref={videoRefBotlabMain}
                >
                  <source src={exploreVideo} type="video/mp4" />
                </video>
              </div>

              <div className="flex flex-col mt-6 w-full relative">
                <div className="flex flex-col md:flex-row gap-6 feature-video-container">
                  <div className="overflow-hidden rounded-md flex-1 h-[50vh]">
                    <img src={explore1Img} alt="titanium" className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]" />
                  </div>

                  <div className="overflow-hidden flex-1 rounded-md h-[50vh]">
                    <video
                      playsInline
                      id="exploreVideoBotlabSide"
                      className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                      preload="none"
                      muted
                      loop
                      autoPlay
                      ref={videoRefBotlabSide}
                    >
                      <source src={exploreVideo1_2} type="video/mp4"/>
                    </video>
                  </div>
                </div>

                <div className="feature-text-container2 p-3 grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_2">
                      Role: Simulation Engineer{" "}
                      <span className="text-white">4+ Years of Experience</span> Part of{" "}
                      <b>4 Guinness World Records</b>
                    </p>
                  </div>

                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_2">
                      Technologies Used: Python, Blender.{" "}
                      <span className="text-white">Hosting Drone Shows Internationally.</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section - Research */}
      <section id="experience-research" className="h-full bg-zinc relative overflow-hidden">
        <div className="screen-max-width">
          <div className="flex flex-col justify-center items-center overflow-hidden">
            <div className="mt-10 mb-4 text-center md:ml-24 md:text-left">
              <h2 id="features_title_3" className="text-3xl md:text-4xl font-semibold mb-8 leading-tight text-center">
                Research Oriented Projects
                <br /> Worked on Various <b><u>AI Research</u> Projects</b>
              </h2>
            </div>

            <div className="flex-center flex-col sm:px-10">
              <a href="#_" className="relative inline-block text-lg group">
                <span className="relative z-10 block px-5 py-3 overflow-hidden font-medium leading-tight text-gray-800 transition-colors duration-300 ease-out border-2 border-gray-900 rounded-lg group-hover:text-white">
                  <span className="absolute inset-0 w-full h-full px-5 py-3 rounded-lg bg-gray-50"></span>
                  <span className="absolute left-0 w-48 h-48 -ml-2 transition-all duration-300 origin-top-right -rotate-90 -translate-x-full translate-y-12 bg-gray-200 group-hover:-rotate-180 ease"></span>
                  <span className="relative">Research</span>
                </span>
                <span className="absolute bottom-0 right-0 w-full h-12 -mb-1 -mr-1 transition-all duration-200 ease-linear bg-gray-200 rounded-lg group-hover:mb-0 group-hover:mr-0" data-rounded="rounded-lg"></span>
              </a>

              <div className="relative h-[50vh] mt-5 w-full flex items-center">
                <video
                  playsInline
                  id="exploreVideoResearchMain"
                  className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                  preload="none"
                  muted
                  loop
                  autoPlay
                  ref={videoRefResearchMain}
                >
                  <source src={exploreVideo2} type="video/mp4"/>
                </video>
              </div>

              <div className="flex flex-col mt-6 w-full relative">
                <div className="flex flex-col md:flex-row gap-6 feature-video-container">
                  <div className="overflow-hidden rounded-md flex-1 h-[50vh]">
                    <img src={explore3Img} alt="titanium" className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]" />
                  </div>

                  <div className="overflow-hidden flex-1 rounded-md h-[50vh]">
                    <video
                      playsInline
                      id="exploreVideoResearchSide1"
                      className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                      preload="none"
                      muted
                      loop
                      autoPlay
                      ref={videoRefResearchSide1}
                    >
                      <source src={exploreVideo3} type="video/mp4"/>
                    </video>
                  </div>
                </div>

                <div className="relative h-[50vh] mt-5 w-full flex items-center">
                  <video
                    playsInline
                    id="exploreVideoResearchSide2"
                    className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                    preload="none"
                    muted
                    loop
                    autoPlay
                    ref={videoRefResearchSide2}
                  >
                    <source src={exploreVideo4} type="video/mp4"/>
                  </video>
                </div>

                <div className="feature-text-container2 p-3 grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_3">
                      One Paper Published.{" "}
                      <span className="text-white">Can implement Research Papers.</span>{" "}
                      <b>3x Hackathon Winner</b>
                    </p>
                  </div>

                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_3">
                      600+ Github Contributions in a year.{" "}
                      <span className="text-white">Trained with Incubation Cell.</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section - AI UI */}
      <section id="experience-ai-ui" className="h-full bg-zinc relative overflow-hidden">
        <div className="screen-max-width">
          <div className="flex flex-col justify-center items-center overflow-hidden">
            <div className="mt-10 mb-4 text-center md:ml-24 md:text-left">
              <h2 id="features_title_4" className="text-3xl md:text-4xl font-semibold mb-8 leading-tight text-center">
                Website building for AI applications.
                <b> Built with Gradio or in collaboration with UI/UX teams.</b>
              </h2>
            </div>

            <div className="flex-center flex-col sm:px-10">
              <a href="#_" className="relative inline-block text-lg group">
                <span className="relative z-10 block px-5 py-3 overflow-hidden font-medium leading-tight text-gray-800 transition-colors duration-300 ease-out border-2 border-gray-900 rounded-lg group-hover:text-white">
                  <span className="absolute inset-0 w-full h-full px-5 py-3 rounded-lg bg-gray-50"></span>
                  <span className="absolute left-0 w-48 h-48 -ml-2 transition-all duration-300 origin-top-right -rotate-90 -translate-x-full translate-y-12 bg-gray-200 group-hover:-rotate-180 ease"></span>
                  <span className="relative">AI with UI</span>
                </span>
                <span className="absolute bottom-0 right-0 w-full h-12 -mb-1 -mr-1 transition-all duration-200 ease-linear bg-gray-200 rounded-lg group-hover:mb-0 group-hover:mr-0" data-rounded="rounded-lg"></span>
              </a>

              <div className="relative h-[50vh] mt-5 w-full flex items-center">
                <img
                  src={explore8Img}
                  alt="Explore Visual"
                  className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                />
              </div>

              <div className="flex flex-col mt-6 w-full relative">
                <div className="flex flex-col md:flex-row gap-6 feature-video-container">
                  <div className="overflow-hidden rounded-md flex-1 h-[50vh]">
                    <img 
                      src={explore9Img} 
                      alt="titanium" 
                      className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                    />
                  </div>

                  <div className="overflow-hidden flex-1 rounded-md h-[50vh]">
                    <img 
                      src={explore10Img} 
                      alt="titanium2" 
                      className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                    />
                  </div>
                </div>

                <div className="feature-text-container2 p-3 grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_4">
                      <span className="text-white">Utilizing Hugging Face and Github related tools for hosting AI-powered services.</span>{" "}
                    </p>
                  </div>

                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_4">
                      <span className="text-white">Collaborated with Clients and for Personal projects.</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Section - Events */}
      <section id="experience-events" className="h-full bg-zinc relative overflow-hidden">
        <div className="screen-max-width">
          <div className="flex flex-col justify-center items-center overflow-hidden">
            <div className="mt-10 mb-4 text-center md:ml-24 md:text-left">
              <h2 id="features_title_5" className="text-3xl md:text-4xl font-semibold mb-8 leading-tight text-center">
                Event Based Company's Planning Operations.
                <b> High Profile Clients.</b> <b>Delivering <u>Photorealistics</u> Renders.</b>
              </h2>
            </div>

            <div className="flex-center flex-col sm:px-10">
              <a href="#_" className="relative inline-block text-lg group">
                <span className="relative z-10 block px-5 py-3 overflow-hidden font-medium leading-tight text-gray-800 transition-colors duration-300 ease-out border-2 border-gray-900 rounded-lg group-hover:text-white">
                  <span className="absolute inset-0 w-full h-full px-5 py-3 rounded-lg bg-gray-50"></span>
                  <span className="absolute left-0 w-48 h-48 -ml-2 transition-all duration-300 origin-top-right -rotate-90 -translate-x-full translate-y-12 bg-gray-200 group-hover:-rotate-180 ease"></span>
                  <span className="relative">StarPord Events</span>
                </span>
                <span className="absolute bottom-0 right-0 w-full h-12 -mb-1 -mr-1 transition-all duration-200 ease-linear bg-gray-200 rounded-lg group-hover:mb-0 group-hover:mr-0" data-rounded="rounded-lg"></span>
              </a>

              <div className="relative h-[50vh] mt-5 w-full flex items-center">
                <img
                  src={explore7Img}
                  alt="Explore Visual"
                  className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]"
                />
              </div>

              <div className="flex flex-col mt-6 w-full relative">
                <div className="flex flex-col md:flex-row gap-6 feature-video-container">
                  <div className="overflow-hidden rounded-md flex-1 h-[50vh]">
                    <img src={explore5Img} alt="titanium" className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]" />
                  </div>

                  <div className="overflow-hidden flex-1 rounded-md h-[50vh]">
                    <img src={explore6Img} alt="titanium2" className="w-full h-full rounded-lg object-cover object-center transform transition-transform duration-300 hover:scale-[0.96]" />
                  </div>
                </div>

                <div className="feature-text-container2 p-3 grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_5">
                      Multiple Freelancing Projects.{" "}
                      <span className="text-white">3000+ 3D Models Sold.</span>{" "}
                    </p>
                  </div>

                  <div className="flex-1 flex-center">
                    <p className="feature-text g_text_5">
                      Collaborated with International Clients.{" "}
                      <span className="text-white">Negotiation, requirement gathering, and delivery coordination were handled with precision and cultural sensitivity.</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Features;
